import { render, staticRenderFns } from "./recentlyContract.vue?vue&type=template&id=f7242e70&scoped=true&"
import script from "./recentlyContract.vue?vue&type=script&lang=js&"
export * from "./recentlyContract.vue?vue&type=script&lang=js&"
import style0 from "./recentlyContract.vue?vue&type=style&index=0&id=f7242e70&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7242e70",
  null
  
)

export default component.exports